import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const ThemeContext = createContext(null);
const SettingsContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("hh_theme") || "dark");
  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("hh_theme", theme);
  }, [theme]);
  const toggle = () => { localStorage.setItem("hh_theme_user", "1"); setTheme((t) => (t === "dark" ? "light" : "dark")); };
  return <ThemeContext.Provider value={{ theme, setTheme, toggle }}>{children}</ThemeContext.Provider>;
}

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const reload = () => api.get("/settings").then((r) => setSettings(r.data));
  useEffect(() => { reload(); }, []);
  return <SettingsContext.Provider value={{ settings, setSettings, reload }}>{children}</SettingsContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
export const useSettings = () => useContext(SettingsContext);
